import React from 'react';
import useMobileBreakpoint from '@src/hooks/useMobileBreakpoint';
import Tile from '@project-stories/elements/Tile/Tile';
import Headings from '@project-stories/elements/Headings/Headings';
import { Paragraph } from '@arctheme-components/elements/Paragraph/Paragraph';
import helpers from 'frontend/js/helpers';

export default function Grid({ settings, columns, headerText, subtext, tagline, customId }) {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const section = settings.section;

  // Responsive values from theme settings
  const columnsCount = isMobile ? section.columns_count_mobile : section.columns_count;
  const gapX = isMobile ? section.gap_mobile : section.gap;
  const gapY = isMobile ? section.gap_y_mobile : section.gap_y;
  const titleStyle = isMobile ? section.header_style_mobile : section.header_style;
  const taglineStyle = isMobile ? section.tagline_style_mobile : section.tagline_style;
  const contentStyle = isMobile ? section.subtext_style_mobile : section.subtext_style_mobile;
  const layoutType = isMobile ? section.layout_mobile : section.layout;

  return (
    <div id={customId || undefined} className={`multicolumn-${layoutType}`}>
      {(tagline || headerText || subtext) && (
        <div
          className={`multicolumn-content-top w-full
          justify-${section.content_alignment_mobile}
          lg:justify-${section.content_alignment_desktop}
          text-${section.content_alignment_mobile}
          lg:text-${section.content_alignment_desktop}
          mb-[${section.header_margin_bottom_mobile}px]
          lg:mb-[${section.header_margin_bottom_desktop}px]
        `}
        >
          {tagline && (
            <Paragraph
              text={tagline}
              type={taglineStyle}
            />
          )}
          {headerText && (
            <Headings
              text={helpers.renderAccentText(headerText, section.accent_title_parts, section.accent_color)}
              type='h2'
              classes={titleStyle}
            />
          )}
          {subtext && (
            <Paragraph
              text={subtext}
              type={contentStyle}
            />
          )}
        </div>
      )}
      <div
        className={`grid w-full grid-cols-${columnsCount} gap-x-[${gapX}px] gap-y-[${gapY}px] ${settings.direction} justify-${section.content_alignment_mobile} lg:justify-${section.content_alignment_desktop}`}
      >
        {columns.map((column, idx) => {
          // Use minHeight for better compatibility on older iPads
          const columnHeight = isMobile ? column.settings.mobile_block_height : column.settings.block_height;
          const minHeightStyle = columnHeight > 0 ? { minHeight: `${columnHeight}px` } : {};

          return (
            <div
              key={column.key || idx}
              className={`box-border flex flex-col justify-stretch h-auto overflow-hidden rounded-[${column.settings.border_radius_mobile}px] lg:rounded-[${column.settings.border_radius}px]`}
              style={column.settings.layout === 'default' ? minHeightStyle : undefined}
            >
              <Tile
                data={column}
                layout={column.settings.layout}
                height={columnHeight > 0 ? `${columnHeight}px` : 'auto'}
                settings={settings}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
